/* eslint-disable no-template-curly-in-string */
export type IIsDateExpression = (expression: string) => boolean;

export function isDateExpression(expression: string): boolean {
  return (
    expression.indexOf('${now}') >= 0 ||
    expression.indexOf('${oneMinute}') >= 0 ||
    expression.indexOf('${oneHour}') >= 0 ||
    expression.indexOf('${oneDay}') >= 0
  );
}
